export enum AppointmentType {
  Standard = 'Standard',
  Reserve = 'Reserve',
  Preparation = 'Preparation'
}
